import React, {useState, useEffect} from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import './index.scss';
import { useSelector } from 'react-redux';

const BreadcrumbBlock = ({ label = 'DASHBOARD', link = 'HOME' }) => {
    const userDetail = useSelector((state)=> state?.user?.user?.organization_detail?.name)
    const image = useSelector((state) => state?.user?.logo)
    const [organization, setOrganization] = useState()
    useEffect(()=>{
        setOrganization(userDetail)
    }, [userDetail])
    return (
        <Breadcrumb tag="nav">
            {image && <img src={image} alt="" width="70" style={{marginRight : "12px"}}/>}
            <BreadcrumbItem active>{organization}</BreadcrumbItem>
            <BreadcrumbItem active>{label}</BreadcrumbItem>
        </Breadcrumb>
    );
};
export default BreadcrumbBlock;